import React, {useEffect} from "react";
import "../css/topMenu.css";
import {postMessageToParentWindow, saveImage} from "../js/handlers";
import Draw from "../js/draw";

// import back from "../images/back.png";
import undo from "../images/undo.png";
import trash from "../images/delete.png";
import save from "../images/save.png";

export default function TopMenu() {
    const qs = new URLSearchParams(window.location.search);

    return (
        <>
            <div className="top_right_menu">
                <button className="undo_button">
                    <img
                        className="top_r_buttons topButtons"
                        src={undo}
                        alt=""
                        data-ga="undo"
                    />
                </button>
                <button className="delete_button">
                    <img
                        className="top_r_buttons topButtons"
                        src={trash}
                        alt=""
                        data-ga="delete"
                    />
                </button>
                <button className="save_button">
                    <img
                        id="save_image"
                        className="top_r_buttons topButtons"
                        src={save}
                        alt=""
                        onClick={qs.get("mode") === "competition" ? postMessageToParentWindow : saveImage}
                        data-ga="save"
                    />
                </button>
            </div>
        </>
    );
}
